exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NotFound-container-gLeWO {\n    margin: 0 auto;\n    padding: 0 0 40px;\n    max-width: var(--max-content-width);\n}\n\n.NotFound-textJumbo-CpK0b {\n    font-size: 145px;\n    font-weight: bold;\n    margin: 0;\n}\n\n.NotFound-textCenter-6zc1u {\n    text-align: center;\n}\n\n.NotFound-listStyled-E-hIK {\n    padding-left: 0;\n    list-style: none;\n}\n\n.NotFound-subTitle-UIIdi {\n    font-size: 15px;\n    color: #db2424;\n}\n\n.NotFound-textColor-nBgGf {\n    color: yellow;\n}\n\n@media (max-width: 1200px) {\n    .NotFound-container-gLeWO {\n        padding: 60px 0 40px;\n    }\n}\n\n@media screen and (max-width: 1199px) {\n    .NotFound-textJumbo-CpK0b {\n        font-size: 85px;\n    }\n}", ""]);

// exports
exports.locals = {
	"container": "NotFound-container-gLeWO",
	"textJumbo": "NotFound-textJumbo-CpK0b",
	"textCenter": "NotFound-textCenter-6zc1u",
	"listStyled": "NotFound-listStyled-E-hIK",
	"subTitle": "NotFound-subTitle-UIIdi",
	"textColor": "NotFound-textColor-nBgGf"
};